import { Place } from '@/types';
import { TabId } from '@/features/NewBenchmarksUI/types/data';

export const updateURLState = (
  setSearchParams: any,
  place: Place | null,
  peers: Place[],
  activeTab?: TabId
) => {
  const params = new URLSearchParams();

  if (place) {
    params.set('name', place.name);
    params.set('place_fips', place.place_fips);
  }

  if (peers.length > 0) {
    params.set(
      'peers',
      peers.map((p) => `${encodeURIComponent(p.name)}:${p.place_fips}`).join(',')
    );
  } else {
    params.delete('peers'); // Remove the peers param if no peers remain
  }

  if (activeTab) {
    params.set('tab', activeTab);
  }

  setSearchParams(params, { replace: true });
}; 